import { Routes, Route, Navigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import RouteWrapper from '../common/RouteWrapper';
import EmailRoutes from '../Email';
import EnterForm from '../../components/Enter/EnterForm';
import ExternalRedirect from '../../utils/ExternalRedirect';
import { paramsKeys } from '../../utils/consts/params';
import { errorParams } from '../../utils/consts/errorParams';
import AccountCode from './AccountCode';

const EnterRoutes = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route
        index
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'enter.seo.title',
              defaultMessage: 'ClearVPN | Enter',
              description: 'SEO title of the Enter page, that provides user with available login options',
            })}
          >
            <EnterForm />
          </RouteWrapper>
        }
      />

      <Route
        path="restore"
        element={<Navigate replace to={`/enter/${paramsKeys.ERROR}=${errorParams.accountTerminated}`} />}
      />

      <Route path="referral" element={<ExternalRedirect to="https://clearvpn.com/redeem/" />} />

      <Route
        path="account-code"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'accountCode.seo.title',
              defaultMessage: 'ClearVPN | Account Code',
              description: 'SEO title of the account code sign up page',
            })}
          >
            <AccountCode />
          </RouteWrapper>
        }
      />

      <Route path="email/*" element={<EmailRoutes />} />

      <Route path="password/*" element={<Navigate replace to="/enter" />} />

      <Route path="login" element={<Navigate replace to={`/enter${window.location.search}`} />} />
    </Routes>
  );
};

export default EnterRoutes;
